import React from "react";
import LayoutHOC from "../LayoutHOC";
import Select from "../UniversalComponents/SelectComponent";
import Input from "../UniversalComponents/InputComponent";
import Button from "../UniversalComponents/DefaultButton";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import CustomerHeaderHoc from "./CustomerHeaderHoc";

const Statement = () => {
  const [selectedValue, setSelectedValue] = useState("");

  const [selectedBalanceValue, setSelectedBalanceValue] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [statementDate, setStatementDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const optionData = ["Print or Review"];
  const statementOptions = [
    { value: "option1", label: "Balance Forward" },
    { value: "option2", label: "Open Item (Last 365 Days)" },
    { value: "option3", label: "Transaction Statement" },
  ];

  const balancesOptions = [
    { value: "option1", label: "All" },
    { value: "option2", label: "Open" },
    { value: "option3", label: "Overdue" },
  ];

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleSelectBalanceChange = (e) => {
    setSelectedBalanceValue(e.target.value);
  };
  const handleSaveButtonClick = () => {
    console.log("Save Button clicked!");
  };
  const handleCancelButtonClick = () => {
    console.log("Cancel Button clicked!");
  };

  const onChange = (dates) => {
    if (Array.isArray(dates)) {
      const [start] = dates;
      setStartDate(start);
    } else {
      setStartDate(dates);
    }
  };

  const onStatementChange = (dates) => {
    if (Array.isArray(dates)) {
      const [start] = dates;
      setStatementDate(start);
    } else {
      setStatementDate(dates);
    }
  };
  const onEndChange = (dates) => {
    if (Array.isArray(dates)) {
      const [start] = dates;
      setEndDate(start);
    } else {
      setEndDate(dates);
    }
  };

  const placeholderDate = "DD-MM-YYYY";
  const displayFormat = "dd-MM-yyyy";

  return (
    <form className="mx-10">
      <div className="  flex gap-3">
        <div className="bg-white border border-[#D6D3D3] px-4 w-[100%] rounded">
          <div className="space-x-2 flex pt-4 justify-between w-[80%]">
            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">Statement Type</label>
              <div>
                <Select
                  placeholder={"Choose Type"}
                  options={statementOptions}
                  value={selectedValue}
                  onChange={handleSelectChange}
                  style={{ width: "100%", height: "35px", padding: "5px", color: "#AFAFAF", fontSize: "12px" }}
                />
              </div>
            </div>
            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">Statement Date</label>
              <div className="w-full">
                <div className="flex items-center bg-white datePicker_container rounded">
                  <DatePicker
                    selected={statementDate}
                    onChange={onStatementChange}
                    startDate={statementDate}
                    placeholderText={placeholderDate}
                    datedivat={displayFormat}
                    className="bg-white border-[#DFE2E5]  w-[100%]   text-gray-800 text-sm block h-[35px] rounded "
                  ></DatePicker>

                  <div>
                    <CalendarWithTimeIcon></CalendarWithTimeIcon>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">Customer Balance Status</label>
              <div>
                <Select
                  placeholder="Choose Status "
                  options={balancesOptions}
                  value={selectedBalanceValue}
                  onChange={handleSelectBalanceChange}
                  style={{ width: "100%", height: "35px", padding: "5px", color: "#AFAFAF", fontSize: "12px" }}
                />
              </div>
            </div>
          </div>
          <div className="flex space-x-2 pt-4 pb-4 w-[53.5%]">
            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">Start Date </label>
              <div className="w-full">
                <div className="flex items-center bg-white datePicker_container rounded">
                  <DatePicker
                    selected={startDate}
                    onChange={onChange}
                    startDate={startDate}
                    placeholderText={placeholderDate}
                    dateFormat={displayFormat}
                    className="bg-white border-[#DFE2E5]  w-[100%]   text-gray-800 text-sm block h-[35px] rounded "
                  ></DatePicker>

                  <div>
                    <CalendarWithTimeIcon></CalendarWithTimeIcon>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">End Date</label>
              <div className="flex items-center bg-white  datePicker_container rounded">
                <DatePicker
                  selected={endDate}
                  onChange={onEndChange}
                  endDate={endDate}
                  placeholderText={placeholderDate}
                  dateFormat={displayFormat}
                  className="bg-white border-[#DFE2E5]  w-[100%]   text-gray-800 text-sm block h-[35px] rounded "
                ></DatePicker>

                <div>
                  <CalendarWithTimeIcon></CalendarWithTimeIcon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between py-3 items-center ">
        <div className="">
          <ul className="flex space-x-3  text-[#009CBF] text-12 font-400">
            {optionData.map((option) => (
              <li key={option}>{option}</li>
            ))}
          </ul>
        </div>

        <div className="flex  space-x-2  ">
          <Button type="primary" onClick={handleCancelButtonClick} style={{ color: "#535252", height: "35px" }}>
            CANCEL
          </Button>
          <Button type="secondary" onClick={handleSaveButtonClick} style={{ height: "35px" }}>
            SAVE
          </Button>
        </div>
      </div>
    </form>
  );
};

export default LayoutHOC(CustomerHeaderHoc(Statement));
